import React from "react";
import { Button } from "../../../../../components/common/Button";
import {
    FormWrapper,
    PaymentDetailsBox,
} from "../../style";
import InputAndSelect from "../../../../../components/common/InputAndSelect";
import { useAppSelector } from "../../../../../app/hooks";

interface Wallet {
    currency: string;
}


interface Props {
    handleNext: () => void;
}


const PaymentDetails = ({handleNext}: Props) => {
    const { wallets } = useAppSelector(
        (state) => state?.wallets || {},
    );

    const filteredWallets = wallets as Wallet[];

    const uniqueCurrencies = Array.from(
        new Set(
            filteredWallets?.map(
                (wallet) => wallet.currency,
            ),
        ),
    );

    const options = uniqueCurrencies.map((currency) => ({
        label: currency,
        value: currency,
    }));
    return (
        <FormWrapper>
            <PaymentDetailsBox>
                <div className="item-flex">
                    <h1>USD 15.00</h1>
                    <p>Account creation fee</p>
                </div>
            </PaymentDetailsBox>

            <PaymentDetailsBox>
                <div className="item-flex">
                    <p>* 0.00126582278481</p>
                    <p>Exchange rate</p>
                </div>
            </PaymentDetailsBox>
            <div>
                <InputAndSelect
                    selectPlaceholder="Currency"
                    width="100%"
                    amountValue={1}
                    onAmountChange={null}
                    options={options}
                    // onSelectChange={handleCurrencyChange}
                />
            </div>
            <Button label="Continue" height="40px" onClick={handleNext} />
        </FormWrapper>
    );
};

export default PaymentDetails;
